import { authClient, baseClient, getServiceURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { ListProjectsService, Project } from '@front/services/ListProjectsService'
import { CanOrderService } from '@front/services/CanOrderService'
import { getServiceURLserverSide } from '@infrastructure/Urls'

export const fetchProjectTypes = ({ lang, catalogId }) => {
	return authClient.get(`${getServiceURL('projects')}/v1/projects/types`, {
		params: { lang, catalogId }
	})
}

export const fetchProjectList = ({ itemsPerPage, page, search, language, sortBy, projectUserRole }) => {
	if (Toggles.isEnabled('listprojectscrmdynamics')) {
		return authClient.get(`${getServiceURLserverSide('v3')}/projects`, {
			params: {
				limit: itemsPerPage?? 5,
				page,
				search,
				language,
				sortBy,
				projectType: projectUserRole,
			}
		})
	}

	if (Toggles.isEnabled('versionateProjectsListView')) {
		return authClient.get(`${getServiceURLserverSide('v3')}/projects/withOutCRM`, {
			params: {
				limit: 5,
				page,
				search,
				language,
				sortBy,
				projectType: projectUserRole,
			}
		})
	}

	if (Toggles.isEnabled('projectsFilterv2')) {
		return authClient.get(`${getServiceURL('apiv2')}/projects/filter`, {
			params: {
				limit: itemsPerPage,
				page,
				search,
				language,
				sortBy,
				projectType: projectUserRole,
			}
		})
	}

	return authClient.get(`${getServiceURL('projects')}/v1/projects/filter`, {
		params: {
			limit: itemsPerPage,
			page,
			search,
			language,
			sortBy,
			projectType: projectUserRole,
			oldApi: true
		}
	})
}

export const fetchProjectsName = () => {
	return authClient.get<Project[]>(`${getServiceURL('projects')}/v1/projects`, {
		params: { type: 'LIST' }
	})
}

export class ListProjectsServiceImpl implements ListProjectsService {
	async fetch(): Promise<Project[]> {
		const res = await fetchProjectsName()
		return res.data
	}
}

export class CanOrderServiceImpl implements CanOrderService {
	async check(projectId: number): Promise<boolean> {
		if (!Toggles.isEnabled('checkProjectIsWon')) {
			return true
		}
		try {
			const res = await authClient.get(`${getServiceURLserverSide('v3')}/project/${projectId}/can_order`, { params: { cache: 'false' } })
			return res.data?.canOrder ?? false
		} catch (err) {
			throw err
		}
	}
}

export const importThirdPartyProject = ({ projectId }) => {
	return new Promise((resolve, reject) =>
		authClient
			.put(`${getServiceURL('projects')}/v1/projects/${projectId}/import`)
			.then((serviceResponse) => {
				resolve({
					...serviceResponse,
					response: {
						...serviceResponse['response'],
						importSuccess: true,
						data: {
							...serviceResponse.data
						}
					}
				})
			})
			.catch((error) => {
				if (error.response.status === 404 || error.response.status === 400) {
					resolve({
						...error,
						response: {
							...error.response,
							status: 200,
							importSuccess: false
						}
					})
				}
				reject(error)
			})
	)
}

export const generateQuoteNumber = () => {
	return baseClient.get(`${getServiceURL('projects')}/v1/budget/final-quote/generate-quote-number`)
}
